<era-panel>
  <div class="p-2">
    <era-pane>
      <era-notes-list [notes]="notes()"
                      (noteUpdated)="noteAdded($event)"
                      (noteRemoved)="noteDeleted($event)"></era-notes-list>
    </era-pane>
  </div>
</era-panel>